import React from "react"
import { User } from "firebase/auth"
import { useForm } from "react-hook-form"
import { SpaceKey } from "popopo-msg"
import { api } from "../../core"

export const SpaceUserSelfForm = (props: { firebase: User; spaceKey: SpaceKey }) => {
  const form = useForm({
    mode: "onBlur",
  })

  const onCreate = async () => {
    try {
      const idToken = await props.firebase.getIdToken()
      await api.POST("/api/v2/spaces/{space_key}/users/me", {
        params: { path: { space_key: props.spaceKey } },
        headers: {
          authorization: `Bearer ${idToken}`,
        },
      })
    } catch (e) {
      console.error(e)
    }
  }

  const onDelete = async () => {
    try {
      const idToken = await props.firebase.getIdToken()
      await api.DELETE("/api/v2/spaces/{space_key}/users/me", {
        params: { path: { space_key: props.spaceKey } },
        headers: {
          authorization: `Bearer ${idToken}`,
        },
      })
    } catch (e) {
      console.error(e)
    }
  }

  return (
    <>
      <form className="d-flex flex-column gap-3 w-100">
        <button type="button" className="btn btn-primary form-control" onClick={form.handleSubmit(onCreate)}>
          Join myself
        </button>

        <button type="button" className="btn btn-primary form-control" onClick={form.handleSubmit(onDelete)}>
          Leave myself
        </button>
      </form>
    </>
  )
}
